import { ReferralInfo as IReferralInfo } from '../../../interfaces';
import { FC, useState } from 'react';
import { Card } from '../../../utilities/components';
import { copyToClipboard } from '../../../scripts';
import { TbCopy } from 'react-icons/tb';
import { Button, Modal } from '../../components';
import { Divider } from 'antd';
import Banner from 'assets/referral/Banner.png';

interface Props {
    info?: IReferralInfo;
    loading: boolean;
}

export const ReferralInvitation: FC<Props> = (props) => {
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    return (
        <Card loading={props.loading} title={'دعوت از دوستان'} titleDivider size={'small'} className={'w-full'}>
            <Modal open={modalOpen} setOpen={setModalOpen} title={'اشتراک گذاری لینک دعوت'}>
                <Divider />
                <img src={Banner} alt={'Banner'} className={"w-full rounded-lg"} />
                <label className={'flex font-bold text-sm text-black-100 mt-4'}>لینک دعوت</label>
                <div
                    className={'flex justify-between items-center pl-2 pr-4 h-12 rounded-[28px] border border-primary-20 mt-2'}>
                    <span />
                    <span
                        className={'font-semibold text-base text-black-100 en whitespace-nowrap text-ellipsis overflow-hidden'}>{`${window.location.origin}?ref=${props.info?.code}`}</span>
                    <Button type={'primary'} icon={<TbCopy />} className={'!h-8 rounded-[32px] max-lg:hidden'}
                            onClick={() => copyToClipboard(`${window.location.origin}?ref=${props.info?.code}`, 'لینک دعوت')}>کپی</Button>
                    <Button type={'primary'} icon={<TbCopy />} className={'!h-8 !min-w-8 rounded-[32px] lg:hidden'}
                            onClick={() => copyToClipboard(`${window.location.origin}?ref=${props.info?.code}`, 'لینک دعوت')} />
                </div>
                <Button type={"primary"} className={"mt-4 w-full"} onClick={() => copyToClipboard(`${window.location.origin}?ref=${props.info?.code}`, 'لینک دعوت')}>کپی کردن لینک دعوت</Button>
            </Modal>
            <div className={'flex flex-col'}>
                <div
                    className={'flex justify-between items-center pl-2 pr-4 h-12 rounded-[28px] border border-primary-20'}>
                    <span className={'font-bold text-sm text-black-100'}>کد دعوت</span>
                    <span className={'font-semibold text-base text-black-100 en'}>{props?.info?.code}</span>
                    <Button type={'primary'} icon={<TbCopy />} className={'!h-8 rounded-[32px] max-lg:hidden'}
                            onClick={() => copyToClipboard(props.info?.code, 'کد دعوت')}>کپی</Button>
                    <Button type={'primary'} icon={<TbCopy />} className={'!h-8 !min-w-8 rounded-[32px] lg:hidden'}
                            onClick={() => copyToClipboard(props.info?.code, 'کد دعوت')} />
                </div>
                <div
                    className={'flex justify-between items-center pl-2 pr-4 h-12 rounded-[28px] border border-primary-20 mt-4'}>
                    <span className={'font-bold text-sm text-black-100'}>لینک دعوت</span>
                    <span
                        className={'font-semibold text-base text-black-100 en whitespace-nowrap text-ellipsis overflow-hidden'}>{`${window.location.origin}?ref=${props.info?.code}`}</span>
                    <Button type={'primary'} icon={<TbCopy />} className={'!h-8 rounded-[32px] max-lg:hidden'}
                            onClick={() => copyToClipboard(`${window.location.origin}?ref=${props.info?.code}`, 'لینک دعوت')}>کپی</Button>
                    <Button type={'primary'} icon={<TbCopy />} className={'!h-8 !min-w-8 rounded-[32px] lg:hidden'}
                            onClick={() => copyToClipboard(`${window.location.origin}?ref=${props.info?.code}`, 'لینک دعوت')} />
                </div>
                <div className={'flex gap-4 mt-6 max-lg:flex-col'}>
                    <Button type={'primary'} className={'w-full'} onClick={() => setModalOpen(true)}>اشتراک گذاری</Button>
                    <Button type={'default'} className={'w-full'} onClick={() => setModalOpen(true)}>تصویر تبلیغاتی</Button>
                </div>
            </div>
        </Card>
    );
};